import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("VoltRoute render error:", error, info?.componentStack);
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-background flex flex-col items-center justify-center px-6 text-center" data-testid="error-boundary-screen">
        <h1 className="font-heading font-extrabold text-2xl mb-3">Oeps, er ging iets mis</h1>
        <p className="text-muted-foreground mb-6 max-w-md">Deze pagina kon niet getoond worden. Herlaad de pagina — meestal is het daarmee opgelost.</p>
        <button data-testid="error-boundary-reload" onClick={() => window.location.reload()}
          className="rounded-full bg-primary hover:bg-[#1B4332] text-primary-foreground px-6 py-3 text-sm font-semibold transition-[background-color] duration-200">
          Herlaad de pagina
        </button>
      </div>
    );
  }
}
